module.exports = "/images/account.svg?9ea039559babc16db39236285cde59ad";